import { useLang } from 'hooks/lang';

import { Button, Column, Row, Tabs } from 'components/Blocks';
import { GoBackButton } from 'components/Buttons';
import {
  ArrowUpIcon,
  CircleCheckIcon,
  CirclePlusIcon,
  MessageHeartCircleIcon,
} from 'components/Icons';

import { OpenSuggestions } from './Open';
import { ClosedSuggestions } from './Closed';

import { useUrlStateV2 } from 'hooks';
import { NewSuggestionModal, SuggestionModal } from '../components';

export default function UserSuggestions() {
  const { t } = useLang();

  const [{ tab }, setParams] = useUrlStateV2({
    tab: {
      defaultValue: 'open',
      validate: (v) => ['open', 'closed'].includes(v),
    },
  });

  const createNode = (
    <NewSuggestionModal
      trigger={
        <Button size="small" className="ml-auto h-auto px-2 py-0.5" variant="ghost">
          <CirclePlusIcon />

          {t('new')}
        </Button>
      }
    />
  );

  return (
    <>
      <SuggestionModal changeTab={(tab) => setParams({ tab })} />

      <Column>
        <Column gap="2">
          <h5 className="flex items-center gap-2 text-3xl font-medium text-primary">
            <GoBackButton />
            {t('user-suggestions')}
          </h5>
        </Column>

        <Row flexWrap="wrap">
          <Tabs
            value={tab}
            onTabChange={(tab) => setParams({ tab })}
            className="-mt-2"
            tabs={[
              {
                value: 'open',
                getLabel: (t) => t('open'),
                icon: MessageHeartCircleIcon,
              },
              {
                value: 'closed',
                getLabel: (t) => t('closed'),
                icon: CircleCheckIcon,
              },
            ]}
          />

          {tab === 'open' ? (
            <div className="ml-auto flex items-center gap-2 text-sm phone:w-full">
              <ArrowUpIcon size={14} color="primary" /> {t('vote-suggestions')}
              {createNode}
            </div>
          ) : (
            createNode
          )}
        </Row>

        {tab === 'open' ? <OpenSuggestions /> : <ClosedSuggestions />}
      </Column>
    </>
  );
}
